import { render } from "./sideNav.vue?vue&type=template&id=50879896"
import script from "./sideNav.vue?vue&type=script&lang=js"
export * from "./sideNav.vue?vue&type=script&lang=js"

import "./sideNav.vue?vue&type=style&index=0&id=50879896&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__